module.exports = __webpack_public_path__ + "static/media/README.949ff34f.md";